var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "root" }, [
    _c(
      "div",
      { staticClass: "schedules" },
      [
        _vm.scheduleEventsPreloader
          ? _c(
              "div",
              { staticClass: "loader" },
              [
                _c("Loader"),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    _vm._s(
                      _vm.missingRequiredFields
                        ? "Buscando a agenda do profissional..."
                        : "Confirmando horario na agenda do profissional..."
                    )
                  )
                ])
              ],
              1
            )
          : _vm.noValidEvents()
            ? _c("div", { staticClass: "empty" }, [
                _vm._v(
                  "\n      Ops, parece que esse profissional não possui mais horários disponíveis.\n    "
                )
              ])
            : _vm._l(_vm.scheduleEvents, function(event) {
                return [
                  _vm.schedulePeriod(event)
                    ? _c(
                        "div",
                        {
                          key: event.id,
                          staticClass: "schedule",
                          class: { selected: event.id === _vm.scheduleEventId },
                          on: {
                            click: function($event) {
                              _vm.handleSetScheduleEvent(event)
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "day" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm._f("day")(event)) +
                                "\n        "
                            )
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "weekday" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm._f("weekday")(event.starts_at)) +
                                "\n        "
                            )
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "period" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.schedulePeriod(event)) +
                                "\n        "
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "icons" }, [
                            _vm.sameDate(event)
                              ? _c("img", {
                                  attrs: {
                                    src: "/static/calendar-outlined.svg"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.initialHour && _vm.insideSchedulePeriod(event)
                              ? _c("img", {
                                  attrs: { src: "/static/clock-outlined.svg" }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.duration && _vm.supportDuration(event)
                              ? _c("img", {
                                  attrs: {
                                    src: "/static/stopwatch-outlined.svg"
                                  }
                                })
                              : _vm._e()
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a8a6fa60", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8a6fa60","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseFlow/Components/Scheduler/Steps/ProfessionalFilters/ScheduleEvents.vue
// module id = null
// module chunks = 